import * as React from 'react';

import { CheckoutOrderFragment } from '@websky/graphql';
import { ExchangeProvider } from '@entities/exchange';
import { Router } from '@shared/lib/router';

import { exchangeRouter } from './router';

interface Props {
	updateOrder: () => Promise<CheckoutOrderFragment>;
}

const Exchange: React.FC<Props> = ({ updateOrder }) => {
	return (
		<ExchangeProvider updateOrder={updateOrder}>
			<Router router={exchangeRouter} />
		</ExchangeProvider>
	);
};

export default Exchange;
